(function() {
  var input = document.getElementById('predictive-search-input');
  var results = document.getElementById('predictive-search-results');
  if (!input || !results) return;

  var debounceTimer, currentQuery = '';
function formatMoney(price) {
  if (price == null) return '';
  return '$' + Math.round(price).toLocaleString('es-CL');
}

  function renderResults(data) {
    var items = [];
    if (data.resources) {
      items = [].concat(
        (data.resources.results.products || []),
        (data.resources.results.pages || []),
        (data.resources.results.articles || [])
      );
    }
    var html = items.length === 0
      ? '<div class="ps-no-results">Sin resultados para "' + currentQuery + '"</div>'
      : items.map(function(item) {
          var thumb = (item.featured_image && item.featured_image.url)
            ? '<img class="ps-thumb" src="' + item.featured_image.url + '" alt="" loading="lazy">'
            : '<div class="ps-thumb-placeholder"></div>';
          var price = item.price ? '<span class="ps-price">' + formatMoney(item.price) + '</span>' : '';
          var type = item.object_type ? '<span class="ps-type">' + item.object_type + '</span>' : '';
          return '<a href="' + item.url + '" role="option">' + thumb +
            '<span class="ps-info"><span class="ps-title">' + item.title + '</span>' + price + type + '</span></a>';
        }).join('');
    results.innerHTML = html;
    results.style.display = 'block';
    input.setAttribute('aria-expanded', 'true');
  }

  function closeResults() {
    results.style.display = 'none';
    input.setAttribute('aria-expanded', 'false');
  }

  function fetchSuggestions(q) {
    currentQuery = q;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=6')
      .then(function(r) { return r.json(); })
      .then(function(data) { if (input.value.trim() === q) renderResults(data); })
      .catch(closeResults);
  }

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    if (q.length < 2) { closeResults(); return; }
    debounceTimer = setTimeout(function() { fetchSuggestions(q); }, 300);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeResults(); input.blur(); }
    if (e.key === 'ArrowDown') { e.preventDefault(); var f = results.querySelector('a'); if (f) f.focus(); }
  });

  results.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeResults(); input.focus(); }
    if (e.key === 'ArrowDown') { e.preventDefault(); var n = document.activeElement.nextElementSibling; if (n) n.focus(); }
    if (e.key === 'ArrowUp') { e.preventDefault(); var p = document.activeElement.previousElementSibling; if (p) p.focus(); else input.focus(); }
  });

  document.addEventListener('click', function(e) {
    if (!input.contains(e.target) && !results.contains(e.target)) closeResults();
  });

  input.addEventListener('focus', function() {
    if (input.value.trim().length >= 2 && results.innerHTML !== '') {
      results.style.display = 'block';
      input.setAttribute('aria-expanded', 'true');
    }
  });
})();
